import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin, ShieldCheck, Clock } from "lucide-react";
import { BUSINESS } from "@/config";

const PLUMBER_IMG =
  "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/0z1jl863_AI%20replacement.jpeg";

const bullets = [
  { icon: MapPin, text: "Edinburgh-based, serving the Lothians" },
  { icon: ShieldCheck, text: "Fully qualified, fully insured" },
  { icon: Clock, text: "30+ years in the plumbing & drainage trade" },
];

const AboutTeaser = () => {
  return (
    <section className="relative py-20 md:py-28 bg-[#0B132B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6 relative overflow-hidden rounded-md border border-[#2C374D]"
          >
            <img
              src={PLUMBER_IMG}
              alt="Conan Sharman Plumbing van and team on a job"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
            <div
              className="absolute inset-0 bg-gradient-to-tr from-[#0B132B] via-[#0B132B]/20 to-transparent"
              aria-hidden
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
              <span className="font-display text-white text-lg md:text-xl tracking-wide">
                ON THE TOOLS, ON YOUR DOORSTEP.
              </span>
              <span className="text-[10px] uppercase tracking-[0.22em] text-[#D47A4A] bg-[#0B132B]/80 px-2.5 py-1 rounded-md border border-[#D47A4A]/30">
                Est. 2011
              </span>
            </div>
          </motion.div>

          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4">
              / 03 — About
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95] tracking-tight">
              REAL TRADE.
              <br />
              <span className="text-[#D47A4A]">REAL PEOPLE.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#A0ABC0] max-w-xl leading-relaxed">
              Conan Sharman has been working in the plumbing and drainage trade
              for over 30 years, building a reputation across Edinburgh and the
              Lothians for honest, professional and reliable work — for both
              domestic and commercial clients.
            </p>

            <ul className="mt-7 space-y-3">
              {bullets.map((b) => {
                const Icon = b.icon;
                return (
                  <li
                    key={b.text}
                    className="flex items-center gap-3 text-sm md:text-base text-[#A0ABC0]"
                  >
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-[#D47A4A]/10 border border-[#D47A4A]/30">
                      <Icon className="w-4 h-4 text-[#D47A4A]" />
                    </span>
                    {b.text}
                  </li>
                );
              })}
            </ul>

            <Link
              to="/about"
              data-testid="home-about-view-more"
              className="group inline-flex items-center gap-2 mt-9 bg-[#D47A4A] hover:bg-[#B85D2A] text-[#0B132B] font-bold px-6 py-3 rounded-md transition-all uppercase tracking-wider text-sm shadow-md shadow-[#D47A4A]/20 hover:shadow-[#D47A4A]/40 hover:-translate-y-0.5"
            >
              Learn More About {BUSINESS.shortName.split(" ")[0]}
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTeaser;
